// shared/performanceLoggerGlobal.ts
import { createPerformanceLogger, LogsPerformatico } from './log-performatico';

export const GlobalPerformanceLogger: LogsPerformatico =
  createPerformanceLogger('GLOBAL');

export const PerformanceMonitor = PerformanceMonitorFactory(
  GlobalPerformanceLogger
);

function PerformanceMonitorFactory(globalLogger: LogsPerformatico) {
  return function PerformanceMonitor(
    options?:
      | {
          name?: string;
          method?: Function;
          ok?: number;
          lento?: number;
          critico?: number;
        }
      | Function
      | string
  ) {
    return function (
      target: any,
      propertyKey: string,
      descriptor: PropertyDescriptor
    ) {
      const originalMethod = descriptor.value;

      let opName: string;
      let customMethod: Function | undefined;
      let customThresholds:
        | { ok?: number; lento?: number; critico?: number }
        | undefined;

      if (typeof options === 'object' && options !== null) {
        opName = options.name || propertyKey;
        customMethod = options.method;
        customThresholds = {
          ok: options.ok,
          lento: options.lento,
          critico: options.critico,
        };
      } else if (typeof options === 'function') {
        opName = options.name || propertyKey;
        customMethod = options;
      } else if (typeof options === 'string') {
        opName = options;
      } else {
        opName = propertyKey;
      }

      descriptor.value = async function (...args: any[]) {
        const instanceLogger = (this as any)
          .performanceLogger as LogsPerformatico;
        const logger = instanceLogger || globalLogger;

        if (logger) {
          logger.startTimer(opName);
          try {
            const methodToCall = customMethod || originalMethod;
            const result = await methodToCall.apply(this, args);
            return result;
          } finally {
            logger.endTimer(opName, undefined, customThresholds);
          }
        } else {
          const methodToCall = customMethod || originalMethod;
          return await methodToCall.apply(this, args);
        }
      };

      return descriptor;
    };
  };
}
